import { render } from "./Loader.vue?vue&type=template&id=05b8999a"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__